import { type FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { type RootState } from '../../../store/store'
import {
  confirmReservationAction,
  enterCustomerInfoAction,
  enterPaymentInfoAction,
  reviewReservationAction,
  rezAdvancedToStep,
  selectReservationDatesAction,
  selectVehicleAction
} from './../../../store/reservationSlice'
import styles from './StepItem.module.scss'

interface StepItemProps {
  stepIndex: number // the number of the step
  stepId: number
  description: string
}

const StepItem: FC<StepItemProps> = ({ stepIndex, stepId, description }: StepItemProps) => {
  const updtReservation = useSelector((state: RootState) => state.reservationSlice.reservation)
  const rezCurrentStep = useSelector((state: RootState) => state.reservationSlice.rezCurrentStep)
  const advancedToStep = useSelector((state: RootState) => state.reservationSlice.rezAdvancedToStep)
  const activeStep = rezCurrentStep?.stepId ?? 1
  const dispatch = useDispatch()
  if (activeStep > advancedToStep) {
    dispatch(rezAdvancedToStep(activeStep ?? undefined))
  }
  async function tabChange(currentStep: number): Promise<void> {
    switch (currentStep) {
      case 1:
        dispatch(selectReservationDatesAction(updtReservation))
        break
      case 2:
        dispatch(selectVehicleAction(updtReservation))
        break
      case 3:
        dispatch(enterCustomerInfoAction(updtReservation))
        break
      case 4:
        dispatch(enterPaymentInfoAction(updtReservation))
        break
      case 5:
        dispatch(reviewReservationAction(updtReservation))
        break
      case 6:
        dispatch(confirmReservationAction(undefined))
        break
      default:
        break
    }
  }
  return (
    <div
      className={`${activeStep === stepId ? styles.StepItemActive : styles.StepItem} ${stepId > advancedToStep ? styles.InactiveTab : ''} steptab`}
      data-testid='StepItem'
    >
      <li className={`tabs-title ${activeStep === stepId ? 'is-active' : ''}`} role='presentation'>
        <a
          className='step-title'
          role='tab'
          id={`${stepIndex}`}
          onClick={async () => {
            await tabChange(stepId)
          }}
        >
          <div className={styles.index}>{stepIndex}</div>
          <div className={styles.description}>{description}</div>
        </a>
      </li>
    </div>
  )
}

export default StepItem
